import { getCountryName } from 'sonata-static-storage/lib/helpers/countries.helpers';
import { worldCountries } from 'sonata-static-storage/lib/samples/worldCountries.samples';

export const getFormattedCountries = (countries: string[]): string[] => {
  const uniqueCountries = Array.from(new Set(countries));
  return uniqueCountries.map(getCountryName);
};

export function getCountryLabel(countryCode: string, defaultValue = 'N/A'): string {
  return worldCountries.find(country => country.cca3 === countryCode.toUpperCase())?.name.common || defaultValue;
}
